'use client';
import React from 'react';

import { TeacherShift } from 'types';

import { Modal } from '@components/Modal';
import { ShiftInfoCard } from '@components/ShiftInfoCards';

interface TeacherShiftModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedShift: TeacherShift | null;
  title: string;
  buttons?: Array<{
    label: string;
    onClick: () => void;
    variant: 'primary' | 'secondary';
    icon?: React.ReactNode;
    disabled?: boolean;
  }>;

  // Modal-specific props
  viewSchool?: boolean;
  substituteName?: string;
  onSubstituteNameChange?: (name: string) => void;
  bringSubstitute?: boolean;
  onBringSubstituteChange?: (checked: boolean) => void;
  triggerValidation?: boolean;
  showContactInfo?: boolean;

  // Additional content
  children?: React.ReactNode;
}

/**
 * Reusable modal component for TeacherShifts
 * Handles different modal types: shift details, ongoing shifts, finished shifts, rejected shifts
 */
export const TeacherShiftModal: React.FC<TeacherShiftModalProps> = ({
  isOpen,
  onClose,
  selectedShift,
  title,
  buttons = [],
  viewSchool = false,
  substituteName,
  onSubstituteNameChange,
  bringSubstitute,
  onBringSubstituteChange,
  triggerValidation,
  showContactInfo = false,
  children,
}) => {
  if (!selectedShift) return null;

  return (
    <Modal
      title={title}
      buttons={buttons}
      isOpen={isOpen}
      onClose={onClose}
      viewSchool={viewSchool}
      substituteName={substituteName}
      onSubstituteNameChange={onSubstituteNameChange}
      bringSubstitute={bringSubstitute}
      onBringSubstituteChange={onBringSubstituteChange}
      triggerValidation={triggerValidation}
      selectedShift={selectedShift}>
      <ShiftInfoCard
        shiftId={selectedShift.id}
        group={selectedShift.group}
        date={selectedShift.shift_date}
        timeFrom={selectedShift.time_from}
        timeUntil={selectedShift.time_till}
        schoolName={selectedShift.school_name}
        status={selectedShift.reaction_status}
        schoolAddress={showContactInfo ? selectedShift.school_address : undefined}
        schoolEnabledWhatsapp={showContactInfo ? selectedShift.school_enabled_whatsapp : undefined}
        contactEmail={showContactInfo ? selectedShift.contact_email : undefined}
        contactPhone={showContactInfo ? selectedShift.contact_phone : undefined}
      />

      {children}
    </Modal>
  );
};
